var exports = {
  "kL": "xa15a2ab7--a71c26--container",
  "H2": "xa15a2ab7--a71c26--container--collapsed",
  "GP": "xa15a2ab7--a71c26--collapse-arrow",
  "Gf": "xa15a2ab7--a71c26--collapse-text",
};

module.exports = exports;
